/*
 * @Author: edvardchen
 * @Date: 2017-07-31 16:42:19
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2019-11-22 16:05:32
 */

// @flow
const actionTypes = {
  UPDATE_STATUS: 'UPDATE_INSTALL_STATUS',
  SHOW_MASK: 'SHOW_WILL_INSTALL_MASK',
  HIDE_MASK: 'HIDE_WILL_INSTALL_MASK',
  SHOW_DB_BAR: 'SHOW_DOWNLOAD_BAR',
  HIDE_DB_BAR: 'HIDE_DOWNLOAD_BAR',
  REMOVE_DB_BAR: 'REMOVE_DOWNLOAD_BAR',
  SHARELP_MODAL: 'SHARELP_MODAL',
};

export { actionTypes };

export const updateStatus = (status: number, percent: number = 0): Object => ({
  type: actionTypes.UPDATE_STATUS,
  status,
  percent,
});

export const showMask = (label: string): Object => ({ type: actionTypes.SHOW_MASK, label });

export const hideMask = (): Object => ({ type: actionTypes.HIDE_MASK });

export const showDBBar = (): Object => ({ type: actionTypes.SHOW_DB_BAR });

export const hideDBBar = (): Object => ({ type: actionTypes.HIDE_DB_BAR });

export const removeDBBar = (): Object => ({ type: actionTypes.REMOVE_DB_BAR });

export const sharelpModal = (show: boolean): Object => ({ type: actionTypes.SHARELP_MODAL, show });
